import { useMutation } from '@apollo/client'

import { INVITE_USER_TO_WORKSPACE } from '../../../../../../data/mutations/user'
import { useAuth } from '../../../../../../hooks/use-auth'
import { useUserQuery } from '../../../../../../hooks/use-user-query'
import type { MembershipAccessType } from '../../../../../../types/user'
import { isEmail } from '../../../../../../utils/common'
import { useWorkspaceMembersAndInvitations } from './use-members-invitations'

interface IUseShipmentMutations {
  workspaceID: string
}

// This custom hook is used to handle the mutations for updating the data of a shipment.
// This is going to be a common mutation hook which will be can be used from any component inside a shipment
export const useShipmentMutations = (props: IUseShipmentMutations) => {
  const { workspaceID } = props

  const { selectedWorkspace } = useAuth()
  const { myDetails } = useUserQuery()

  const customHeaderContext = {
    headers: workspaceID ? { 'ws-id': workspaceID } : {}
  }

  const { refetchWorkspaceInvitations } = useWorkspaceMembersAndInvitations(
    workspaceID,
    selectedWorkspace?.workspace.id || ''
  )

  const [inviteUserToWorkspace] = useMutation(INVITE_USER_TO_WORKSPACE, {
    context: {
      ...customHeaderContext
    },
    onCompleted() {
      refetchWorkspaceInvitations()
    }
  })

  const handleInviteToWorkspace = ({
    id,
    emailOrPhone,
    accessType
  }: {
    accessType: MembershipAccessType
    emailOrPhone: string
    id: string
  }) => {
    const input = {
      accessType: accessType,
      countryCode: '+1',
      email: isEmail(emailOrPhone) ? emailOrPhone : undefined,
      invitedByID: myDetails?.id,
      phone: !isEmail(emailOrPhone) ? emailOrPhone : emailOrPhone.slice(2),
      userID: id,
      workspaceID: workspaceID
    }
    inviteUserToWorkspace({ variables: input })
  }

  return {
    handleInviteToWorkspace
  }
}
